export enum RiskScenarioCategory {
    Ransomware = 1,
    Malware = 2,
    SocialEngineering = 3,
    Interception = 4,
    DataThreats = 5,
    AvailabilityThreats = 6,
    InformationManipulation = 7,
    SupplyChainAttack = 8,
    PhysicalAttack = 9,
    UnintentionalDamage = 10,
    Outages = 11,
    Disaster = 12,
    ConcentrationRisk = 13,
    Legal = 14,
    PrivacyAndDataProtection = 15,
    AiAndAlgorithmic = 16,
    OrganisationalAndGovernance = 17,
}

export interface RiskScenarioSaveModel {
    id: string;
    name: string;
    description?: string;
    category: string;
    riskAreaIds: string[];
    entityTypes: number[];
}
